import { Component, OnInit } from '@angular/core';
import { FrontOffService, Dropobj,HrmsService,MasterService, LibraryService } from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {WebcamImage} from 'ngx-webcam';
import {Subject, Observable} from 'rxjs';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-libmembers',
  templateUrl: './libmembers.component.html',
  styleUrls: ['./libmembers.component.scss'],
  providers:[FrontOffService,HrmsService,MasterService,LibraryService],
})
export class LibmembersComponent implements OnInit {
  arremp:any=[];
  arrdept:any=[];
  arrdept1:any=[];
  defdep:any;
  arrdesig:any=[];
  arrdesig1:any=[];
  memberdash:any={};
  defdes:any;
  emparr:any=[];
  emparr1:any=[];
  statuses:any=[{value:'Active',name:'Active'},{value:'Inactive',name:'Inactive'}];
  arrstatus=[{name:'Active'},{name:'Inactive'}];
  defstat='Active';
  arrcourse:any=[];
  arrcourse1:any=[];

  classes:any=[];
  arrclass1:any=[];
  defclass:any;
  defcorse:any;
  studentarr:any=[];
  studentarr1:any=[];

  

  constructor(private http: HttpClient,private mservice:MasterService, private fservice: FrontOffService, private hservice: HrmsService, private liservice: LibraryService,private modalService: NgbModal) { }

  ngOnInit(): void {
    this.memberdashcnts('stuinfocnts');
    this.studentclick();
  }

  staffclick()
  {
    this.getemployes();
    this.getdesignation();
    this.gethrmdept();
  }

  studentclick()
  {
    this.getstudents('s',0);
    this.masclass();
   
    this.mascourse();
    

  }
  gethrmdept() {
    this.mservice.get_hrmdept()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrdept = resultArray;
            this.arrdept1=resultArray;
this.arrdept1.unshift({depid:"0",depnm:"ALL"});
this.defdep="0";
           
        },
        error => console.log("Error :: " + error)
        )
  }


  getdesignation() {
    this.mservice.sel_sp_hrmdesig()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrdesig = resultArray;

            this.arrdesig1=resultArray;
this.arrdesig1.unshift({desid:"0",desnm:"ALL"});
this.defdes="0";
           
        },
        error => console.log("Error :: " + error)
        )
  }


  getemployes() {
    this.hservice.getemployes()
        .subscribe(
        resultArray => {
            console.log('getlibdepartment', resultArray);
            this.emparr = resultArray.emplst;
            this.emparr1 = resultArray.emplst;
          var activeemps   = resultArray.emplst.filter(function(arr)
            {
        
              return arr.emstatus=='Active';
            });
            this.arremp= activeemps.map( o => { return { emid: o.emid, emnm: o.emnm} });
           // this.admdash=resultArray.empinfo;
            console.log('arremp',this.arremp);
            
        },
        error => console.log("Error :: " + error)
        )
  }

  
  memberdashcnts(oprtype) {
    this.liservice.getmemberdetails(oprtype,'',0,0)
        .subscribe(
        resultArray => {
            console.log('members-result', resultArray);
            this.memberdash = resultArray[0];
            
        },
        error => console.log("Error :: " + error)
        )
  }

  getstudents(oprtype,stuid) {
    this.fservice.getstudents(oprtype,stuid)
        .subscribe(
        resultArray => {
            console.log('getlibdepartment', resultArray);
            this.studentarr = resultArray.stulst;
            this.studentarr1 = resultArray.stulst;
  
            //this.admdash=resultArray.studash;
            
        },
        error => console.log("Error :: " + error)
        )
  }


  onchangeemployee()
  {
    debugger
  if(this.defdep=="0" && this.defdes=="0" )
  {
  
    this.emparr=this.emparr1.filter(item => item.emstatus===this.defstat);
  }
  
  else if(this.defdep!="0" && this.defdes!="0" )
  {
  
    this.emparr=this.emparr1.filter(item => item.emstatus===this.defstat && item.depid===this.defdep && item.desid===this.defdes);
  }
  
  // else if(this.defclass!="0" && this.defcorse!="0" )
  // {
  
  //   this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat && item.clid===this.defclass && item.crid===this.defcorse);
  // }
  
  else if(this.defdep!="0" && this.defdes==="0" )
  {
  
    this.emparr=this.emparr1.filter(item => item.emstatus===this.defstat && item.depid===this.defdep );
  }
  
  else if(this.defdep==="0" && this.defdes!="0" )
  {
  
    this.emparr=this.emparr1.filter(item => item.emstatus===this.defstat && item.desid===this.defdes );
  }
    //if()
  }

  exportstaff(){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     //var url=this.liservice.callurl+"export/expstudent.php?clcd="+clcd+"&aycd="+aycd+"&oprtype="+oprtype+"&clid="+this.defclass+"&crid="+this.defcorse;
     var url=this.hservice.callurl+"export/expstaff.php?clcd="+clcd+"&aycd="+aycd;
  
     window.open(url,'','');
   }

   exportrecord(tag){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     //var url=this.liservice.callurl+"export/expstudent.php?clcd="+clcd+"&aycd="+aycd+"&oprtype="+oprtype+"&clid="+this.defclass+"&crid="+this.defcorse;
     //var url=this.fservice.callurl+"export/expstudent.php?clcd="+clcd+"&aycd="+aycd+"&alclnew="+tag;
     var url=this.fservice.callurl+"export/expstudent.php?clcd="+clcd+"&aycd="+aycd+"&alclnew="+tag+"&tag=stuclassdetail&crid="+this.defcorse+"&clid="+this.defclass+"&scid=0";
     window.open(url,'','');
   }

  onchangefilters()
{
  debugger
if(this.defclass=="0" && this.defcorse=="0" )
{

  this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat);
}

else if(this.defclass!="0" && this.defcorse!="0" )
{

  this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat && item.clid===this.defclass && item.crid===this.defcorse);
}

// else if(this.defclass!="0" && this.defcorse!="0" )
// {

//   this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat && item.clid===this.defclass && item.crid===this.defcorse);
// }

else if(this.defclass!="0" && this.defcorse==="0" )
{

  this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat && item.clid===this.defclass );
}

else if(this.defclass==="0" && this.defcorse!="0" )
{

  this.studentarr=this.studentarr1.filter(item => item.stustatus===this.defstat && item.crid===this.defcorse );
}
  //if()
}

  masclass() {
    this.fservice.masclass()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.classes = resultArray;
            this.arrclass1=resultArray;
  this.arrclass1.unshift({clid:"0",clnm:"ALL"});
  this.defclass="0";
           
        },
        error => console.log("Error :: " + error)
        )
  }

  mascourse() {
    this.fservice.mascourse()
        .subscribe(
        resultArray => {
            console.log('arcourse', resultArray);
            this.arrcourse = resultArray;
            this.arrcourse1=resultArray;
    this.arrcourse1.unshift({crid:"0",crnm:"ALL"});
           this.defcorse="0";
        },
        error => console.log("Error :: " + error)
        )
  }
}
